import { ChangeDetectorRef, Component } from '@angular/core'
import { GlobalMessageType, RoutingService, TranslationService } from '@spartacus/core'
import { FileSaverService } from 'ngx-filesaver'
import { combineLatest } from 'rxjs'
import { delay, finalize, tap } from 'rxjs/operators'
import { SharedValue } from '../../../models/enum/shared.enum'
import { CustomCartService } from '../../../services/custom-cart.service'
import { OrderHistoryService } from '../../../services/order-history.service'
import { CustomGlobalMessageService } from '../../../services/shared/custom-global-message/custom-global-message.service'
import { CustomModalService } from '../../../services/shared/modal/custom-modal.service'
import { ConfirmModalComponent, DataConfirmModal } from '../../shared/confirm-modal/confirm-modal.component'

@Component({
    selector: 'app-import-saved-cart',
    templateUrl: './import-saved-cart.component.html',
    styleUrls: ['./import-saved-cart.component.scss'],
    standalone: false
})
export class ImportSavedCartComponent {
  public selectedFile: File
  public fileInputControl: any
  public showSpinnerDownloadTemplate: boolean
  public showSpinnerValidateCsv: boolean
  public showSpinnerUpload: boolean
  public disableImport = true
  public disableOnUpload: boolean

  constructor(
    private cartService: CustomCartService,
    private globalMessageService: CustomGlobalMessageService,
    private changeDetectorRef: ChangeDetectorRef,
    private fileSaverService: FileSaverService,
    private translationService: TranslationService,
    private customModalService: CustomModalService,
    private routing: RoutingService,
    private orderHistoryService: OrderHistoryService
  ) {}

  public browseFile(fileList: FileList): void {
    this.disableImport = true
    if (!fileList || !fileList.length) {
      this.selectedFile = null
      this.fileInputControl = null
      return
    }

    this.showSpinnerValidateCsv = true
    this.selectedFile = fileList[0]
    this.cartService
      .validateCsvTemplate(this.selectedFile)
      .pipe(
        finalize(() => {
          this.showSpinnerValidateCsv = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe(
        () => {
          this.disableImport = false
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
        },
        (err) => {
          this.selectedFile = null
          this.fileInputControl = null
          this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        }
      )
  }

  public uploadCSV(): void {
    combineLatest([
      this.translationService.translate('modals.restoreCart.title'),
      this.translationService.translate('modals.restoreCart.msg'),
      this.translationService.translate('modals.restoreCart.extra'),
      this.translationService.translate('modals.restoreCart.yes')
    ]).subscribe(([title, msg, extra, yes]) => {
      const dataModal: DataConfirmModal = { title, msg, extra, yes }
      this.customModalService.showConfirmModal(ConfirmModalComponent, dataModal).then((ok) => {
        if (!ok) {
          return
        }

        this.showSpinnerUpload = true
        this.disableOnUpload = true
        this.changeDetectorRef.detectChanges()
        this.cartService
          .uploadCSVCart(this.selectedFile)
          .pipe(
            tap((res) => {
              this.orderHistoryService.loadReorderedCart(res?.savedCartData?.code)
            }),
            delay(2000),
            finalize(() => {
              this.showSpinnerUpload = false
              this.disableOnUpload = false
              this.disableImport = true
              this.selectedFile = null
              this.fileInputControl = null
              this.changeDetectorRef.detectChanges()
            })
          )
          .subscribe(
            () => {
              this.globalMessageService.add({ key: 'importCart.cartImported' }, GlobalMessageType.MSG_TYPE_CONFIRMATION)
              this.routing.goByUrl('cart')
            },
            (err) => {
              this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
            }
          )
      })
    })
  }

  public downloadCsvTemplate(): void {
    this.showSpinnerDownloadTemplate = true
    this.cartService
      .downloadCsvTemplate()
      .pipe(
        finalize(() => {
          this.showSpinnerDownloadTemplate = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe(
        (res) => {
          this.fileSaverService.save(res.body, 'Cart Upload.csv')
        },
        () => {
          this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
        }
      )
  }

  public get disableUploadCSV(): boolean {
    return this.disableImport || this.disableOnUpload
  }
}
